import { signedApiClient } from '@/services/apiClient';

export class StudySettingsService {

  initService() {
  }

  async getUserAvatar(avatarURL: string) {
    const uri = `${avatarURL}/base64`;
    const apiClient = signedApiClient('GET', uri);

    const response = await apiClient.get(uri);
    const formattedModel: string = response.data;
    return formattedModel;
  }
}

export default new StudySettingsService();
